import { styled } from '@mui/material';

import { Button } from '../button';

export const FilterButton = styled(Button)(({ theme }) => ({
  // there is no way to get this value from the theme
  // https://github.com/mui/material-ui/blob/4c6f67e1bec832408e609ac555ea67100da4fa81/packages/mui-material/src/OutlinedInput/OutlinedInput.js#L108
  padding: '8.5px 14px',
  textTransform: 'none',
  color: theme.palette.text.primary,
  letterSpacing: 'normal',
  // https://github.com/mui/material-ui/blob/4c6f67e1bec832408e609ac555ea67100da4fa81/packages/mui-material/src/OutlinedInput/OutlinedInput.js#L47
  borderColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)',
  '&:hover': {
    borderColor: theme.palette.text.primary,
    background: 'none',
  },
  '&:active': {
    borderColor: theme.palette.text.primary,
  },
  '&:focus': {
    borderColor: theme.palette.text.primary,
  },
  '&.Mui-disabled': {
    borderColor: theme.palette.action.disabled,
  },
}));
